<template>
  <the-main-wrapper>
    <div class="not-found-page">
      <lottie :options="errorOptions" :height="300" :width="300" v-on:animCreated="handleAnimation" />
      <lottie :options="noConnectionsOptions" :height="300" :width="300" v-on:animCreated="handleAnimation" />
    </div>
  </the-main-wrapper>
</template>

<script>
import Lottie from './Lottie.vue';
import { AuthControl } from '@/services/SecurityService';
import * as error from '@/assets/animations/error.json';
import * as noConnection from '@/assets/animations/no_connection.json';

import TheMainWrapper from '@/components/TheMainWrapper';

export default {
  components: {
    lottie: Lottie,
    TheMainWrapper
  },
  data() {
    return {
      authControl: new AuthControl(),
      errorOptions: { animationData: error.default },
      noConnectionsOptions: { animationData: noConnection.default },
      animationSpeed: 1
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    }
  },
  beforeMount() {
    this.authControl.getSignedIn().then(isLogged => {
      if (!isLogged) this.$router.push({ name: 'home' });
    });
  }
};
</script>

<style style="scss" scoped>
.not-found-page {
  background-color: var(--v-secondary-base);
}
</style>
